import React from 'react';

export const AccessDeniedPage = () => {

    return <div className="accessDeniedPageContainer">
        <h1>Nemáte práva</h1>
    </div>
}